












import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  基本
 * @desc 最基本的用法。
 */
@Component
export default class BasicExample extends Vue {
}
